export const SIZE = {
  mobileMin: `360px`,
  tablet: `768px`,
};

export const COLOR = {
  bg_blue: `#B1C7DE`,
  bg_pink: `#F7CAC9`,
  bg_white: `#FDFDFD`,
  dark_pink: `#C88EA7`,
  // btn_pink: `#E19FAE`,
  btn_pink: `#982F41`,
  btn_blue: `#7289A4`,
  btn_dark_blue: `#213F5C`,
  btn_pink_hover: `#EBBFCB`,
  btn_blue_hover: `#92A8D1`,
};
